import './input.scss';
import React, { createRef } from 'react';

export interface IProps {
    placeholder: string;
    value?: string;
    defaultValue?: string;
    className?: string;
    maxLength?: number;
    onChange?: (val: string) => void;
}

export function Input(props: IProps) {
    const { placeholder, defaultValue, onChange, className, value, maxLength = 200 } = props;
    const elRef = createRef<HTMLInputElement>();
    const handleChange = () => {
        if (elRef.current && !!onChange) {
            onChange(elRef.current.value);
        }
    }
    return (
        <div className={`form-input ${className}`}>
            <input
                type="text"
                ref={elRef}
                className="input"
                placeholder={placeholder}
                defaultValue={defaultValue}
                onChange={handleChange}
                value={value}
                spellCheck={false}
                maxLength={maxLength}
                autoComplete={'off'}
            />
        </div>
    );
}
